// extracted by mini-css-extract-plugin
export var checkoutHoverCard = "_m8-2";
export var interactiveWrapper = "_m8-0";
export var shippingHoverPreview = "_m8-4";
export var summaryBadgeTrigger = "_m8-1";
export var widgetHoverPreviewList = "_m8-3";
export var widgetPreviewScale = "_m8-5";